import { Component, View, ViewModel } from "binder";
import { PopupViewModel, Position } from "../popup/popup-viewModel";
import { ITemplateSelector } from "../templateSelector";
import  { TooltipView } from "./tooltip-view"

export class TooltipViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.showtimeout = 300;
        this.closetimeout = 500;
    }
    GetDefaultView(): View <ViewModel> {
        return new TooltipView();
    }
    public getTypeId(): string {
        return "VM-D50F157F-CE57-4E1D-8A55-8B44AFFA86CE"
    }
    public set showtimeout(v: number) { this._showtimeout = v; } public get showtimeout(): number { return this._showtimeout;} private _showtimeout: number;
    public set closetimeout(v: number) { this._closetimeout = v; } public get closetimeout(): number { return this._closetimeout;} private _closetimeout: number;
    public set popup(v: PopupViewModel) { this._popup = v; } public get popup(): PopupViewModel { return this._popup;} private _popup: PopupViewModel;    
    public set thisElement(v: HTMLElement) { this._thisElement = v; } public get thisElement(): HTMLElement { return this._thisElement;} private _thisElement: HTMLElement;

    private _isapplying:boolean;
    private _timer;
    public set isMouseOver(v: boolean) { 
        if(this._isMouseOver == v)
            return;
        this._isMouseOver = v; 
        if(this.isMouseOver==this.popup.isShowing && this._isapplying){
            this._isapplying = false;
            clearTimeout(this._timer);
        }else if(this.isMouseOver!=this.popup.isShowing && this._isapplying!=true){
            this._timer = setTimeout(()=>{
                if(this.isMouseOver){
                    let rect = this.thisElement.getBoundingClientRect();
                    this.popup.origin = new Position(rect.x,rect.y,rect.width,rect.height);
                }
                this.popup.isShowing = this.isMouseOver;
                if(this.isMouseOver){
                    let event = new Event('shown');
                    this.thisElement.dispatchEvent(event);
                }
                this._isapplying = false;
            },this.isMouseOver ? this.showtimeout : this.closetimeout);
            this._isapplying = true;
        }
    } public get isMouseOver(): boolean { return this._isMouseOver;} private _isMouseOver: boolean;
    
}
